import React from 'react';
import './AutoLexiSeparator.css';

const AutoLexiSeparator = ({ flip }) => (
  <div className={`auto-lexi-separator${flip ? ' auto-lexi-separator-flip' : ''}`}>
    <svg viewBox="0 0 1000 140" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
      <path d="M100,70 L900,70" stroke="#b09fc4" strokeWidth="5" fill="none"/>
      <path
        d="M150,70 Q200,20 250,70 M300,70 Q350,20 400,70 M450,70 Q500,20 550,70 M600,70 Q650,20 700,70 M750,70 Q800,20 850,70"
        stroke="#b09fc4" strokeWidth="5" fill="none"
      />
      <circle cx="100" cy="70" r="8" fill="#b09fc4"/>
      <circle cx="900" cy="70" r="8" fill="#b09fc4"/>
    </svg>
  </div>
);

export { AutoLexiSeparator };
